import { useTranslation } from 'react-i18next';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { TRIAL_DAYS } from '@/config';
import { formatPrice } from '@/utils';
import { useMedia } from '@/hooks/responsive';

export function TrialPlan({
	title,
	trialPlan,
	trialPlanPrice,
	discount,
	cheapestPlan
}) {
	const { t } = useTranslation();
	const mdDown = useMedia('mdDown');

	return (
		<>
			<Box py={2}>
				<Stack flexDirection="row" justifyContent="space-between">
					<Stack>
						<Typography
							variant={mdDown ? 'body0' : 'body1'}
							fontWeight={700}
						>
							{title ||
								t('plans.creditsPlan', {
									quantity: trialPlan.credits ?? 0
								})}
						</Typography>
						<Typography
							variant="body0"
							color="text.secondary"
							sx={{ whiteSpace: { xs: 'pre-line', md: 'initial' } }}
						>
							{t('fastCheckout.trialName', {
								trialDays: TRIAL_DAYS,
								bestPrice: formatPrice({
									amount: cheapestPlan.baseAmount,
									currency: cheapestPlan?.currency
								})
							})}
						</Typography>
					</Stack>

					<Stack
						direction="row"
						alignItems="center"
						spacing={1}
						useFlexGap
					>
						{!!discount && (
							<Box
								display="flex"
								alignItems="center"
								justifyContent="center"
								sx={theme => ({
									background: theme.palette.text.primary,
									px: 0.5,
									height: 20,
									borderRadius: 1
								})}
							>
								<Typography
									variant="body0"
									fontWeight={700}
									color="background.default"
								>
									{t('common.discount', {
										discount
									})}
								</Typography>
							</Box>
						)}
						<Typography
							variant="body3"
							fontSize={{ xs: 20, sm: 24 }}
							fontWeight={700}
						>
							{trialPlanPrice}
						</Typography>
					</Stack>
				</Stack>
			</Box>
			<Divider orientation="horizontal" />
		</>
	);
}
